type PageCoordinates = Array<number>;

export const getPropertyScaleFactor = () => {
  const pdfViewer = document.querySelector('.pdfViewer');

  if (!pdfViewer) return 1;

  return Number(getComputedStyle(pdfViewer).getPropertyValue('--scale-factor').trim());
};

/**
 * @description set the max value that a signature can be positioned in that case is
 * max page content box top and bottom, after get the min value between user
 * positioned and max value
 */
export const calculateMaxCoordinatePosition = (coordinates: PageCoordinates, clickedPage: HTMLDivElement, signatureElement: HTMLElement) => {
  const [x, y] = coordinates;

  if (x === undefined || y === undefined) return [0, 0];

  const scale = getPropertyScaleFactor();

  const leftPage = clickedPage.offsetLeft;
  const signWidth = signatureElement.offsetWidth * scale;
  const pageBoundRight = leftPage + clickedPage.offsetWidth - signWidth;

  const finalX = Math.min(x, pageBoundRight);

  const topPage = clickedPage.offsetTop;
  const signHeight = signatureElement.offsetHeight * scale;
  const pageBoundBottom = topPage + clickedPage.offsetHeight - signHeight;

  const finalY = Math.min(y, pageBoundBottom);

  return [finalX, finalY];
};

export const coordinateBasedOnOffsetAndPosition = (pageElement: HTMLElement, position: Array<number> = []) => {
  const { width, height } = pageElement.getBoundingClientRect();

  if (position.length === 0) return [0, 0];

  const [percentageX = 0, percentageY = 0] = position;

  const x = width * percentageX + pageElement.offsetLeft;
  const y = height * percentageY + pageElement.offsetTop;

  return [x, y];
};
